import { render, staticRenderFns } from "./SubscriptionPlan.vue?vue&type=template&id=64903ba5&"
import script from "./SubscriptionPlan.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPlan.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPlan.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports